module.exports = __webpack_public_path__ + "img/2.c55f380c.jpeg";